function PizzaLoader() {
  return (
    <div className="vh-100 d-flex flex-column justify-content-center align-items-center text-center">
      <div className="loader"></div>
      <div className="loader-container d-flex flex-md-row flex-column justify-content-center align-items-center pt-2">
        <div className="fixed-text">Time to </div>
        <div className="scrolling-box">
          <ul className="words">
            <li className="d-flex justify-content-center justify-content-md-start text-nowrap">
              Eat Good
            </li>
            <li className="d-flex justify-content-center justify-content-md-start text-nowrap">
              Order Now
            </li>
            <li className="d-flex justify-content-center justify-content-md-start text-nowrap">
              Feast Big
            </li>
            <li className="d-flex justify-content-center justify-content-md-start text-nowrap">
              Taste Magic
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PizzaLoader;
